import { Component, Input } from "@angular/core";

import {
    MeasureYourselfBlock,
    MeasureYourselfImageMedia,
    MeasureYourselfPdf,
    MeasureYourselfSteps,
    MeasureYourselfTable,
} from "@hermes/api-model-product";

import {
    BLOCK_PDF,
    BLOCK_STEPS,
    BLOCK_IMAGE_MEDIA,
    BLOCK_TABLE,
    SIZE_GUIDE_BLOCK,
    SIZE_GUIDE_BLOCK_TABLE,
} from "../constants/size-guide.constant";

@Component({
    selector: "h-measure-yourself",
    templateUrl: "./measure-yourself.component.html",
    styleUrl: "./measure-yourself.component.scss",
})
export class MeasureYourselfComponent {
    @Input({ required: true })
    public measureYourself: MeasureYourselfBlock[] | undefined;

    public SIZE_GUIDE_BLOCK = SIZE_GUIDE_BLOCK;
    public SIZE_GUIDE_BLOCK_TABLE = SIZE_GUIDE_BLOCK_TABLE;

    public isPdfBlock(
        block: MeasureYourselfBlock,
    ): block is MeasureYourselfPdf {
        return block.paragraphType === BLOCK_PDF;
    }

    public isTableBlock(
        block: MeasureYourselfBlock,
    ): block is MeasureYourselfTable {
        return block.paragraphType === BLOCK_TABLE;
    }

    public isStepsBlock(
        block: MeasureYourselfBlock,
    ): block is MeasureYourselfSteps {
        return block.paragraphType === BLOCK_STEPS;
    }

    public isImageBlock(
        block: MeasureYourselfBlock,
    ): block is MeasureYourselfImageMedia {
        return block.paragraphType === BLOCK_IMAGE_MEDIA;
    }
}
